// extracted by mini-css-extract-plugin
module.exports = {"menuColor":"#fff","menuTextColor":"#333","menuActiveTextColor":"#888"};